import React, { useState, useEffect } from "react";
import { useOrderDetailsService } from "../../../services/component/orderDetailsService";
import ModalContentCenter from "../../modalContentCenter/ModalContentCenter";

const TimeOut: React.FC = () => {
  const orderDetailsService = useOrderDetailsService();
  const [showTimeout, setShowTimeout] = useState(false);

  useEffect(() => {
    const unsub = orderDetailsService.showTimeoutModal$.subscribe((show) => {
      if (show) setShowTimeout(true);
    });
    return () => unsub();
  }, [orderDetailsService]);

  const refreshOrderSummary = () => {
    orderDetailsService.resetTimer("reset");
    orderDetailsService.refreshorder("refresh");
  };

  const closeTimeModal = () => {
    setShowTimeout(false);
    orderDetailsService.announceDetailClose("close");
  };

  return (
    <ModalContentCenter visible={showTimeout}>
      <div className="modal-fade timeout-modal" role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="footer-modal-header" style={{ backgroundColor: "#e41f32", color: "white", padding: "5px" }}>
              <button type="button" className="btn btn-default close" onClick={() => { refreshOrderSummary(); closeTimeModal(); }}>&times;</button>
              <h4 style={{ fontSize: "12px" }}>Time Out</h4>
            </div>
            <div className="footer-modal-body">
              <p>You have reached the time limit for approving this order</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" style={{ backgroundColor: "#e41f32", color: "white", fontSize: "10px" }}
                onClick={() => { refreshOrderSummary(); closeTimeModal(); }}>OK</button>
            </div>
          </div>
        </div>
      </div>
    </ModalContentCenter>
  );
};

export default TimeOut;
